import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import UILink from 'UIComponents/link/UILink';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes, isLegacyComponent } from './internal/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO: refactor to use Link after deprecating UIComponents part
/**
 * A [`Link`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-link--page)
 * type component with router support.
 */
export default function UIRouterLink(props) {
  // TODO remove this logic after deprecating style & className props
  const LinkComponent = isLegacyComponent(props, ['style', 'className']) ? UILink : Link;
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: LinkComponent
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);

// TODO remove after deprecating UIComponents part
UIRouterLink.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, clonePropTypes(UILink));

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIRouterLink.defaultProps = cloneDefaultProps(UILink);